/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderBigTableKoreaTrackVo
 */
export interface OrderBigTableKoreaTrackVo {
    /**
     * 主键id
     * @type {number}
     * @memberof OrderBigTableKoreaTrackVo
     */
    id?: number;
    /**
     * 订单id
     * @type {number}
     * @memberof OrderBigTableKoreaTrackVo
     */
    orderId?: number;
    /**
     * 运输公司编码
     * @type {string}
     * @memberof OrderBigTableKoreaTrackVo
     */
    transportCompanyCode?: string;
    /**
     * 是否主运单  1 是 0 不是
     * @type {number}
     * @memberof OrderBigTableKoreaTrackVo
     */
    main?: number;
    /**
     * 运单号
     * @type {string}
     * @memberof OrderBigTableKoreaTrackVo
     */
    trackingNumber?: string;
}

/**
 * Check if a given object implements the OrderBigTableKoreaTrackVo interface.
 */
export function instanceOfOrderBigTableKoreaTrackVo(value: object): value is OrderBigTableKoreaTrackVo {
    return true;
}

export function OrderBigTableKoreaTrackVoFromJSON(json: any): OrderBigTableKoreaTrackVo {
    return OrderBigTableKoreaTrackVoFromJSONTyped(json, false);
}

export function OrderBigTableKoreaTrackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderBigTableKoreaTrackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'transportCompanyCode': json['transportCompanyCode'] == null ? undefined : json['transportCompanyCode'],
        'main': json['main'] == null ? undefined : json['main'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
    };
}

export function OrderBigTableKoreaTrackVoToJSON(json: any): OrderBigTableKoreaTrackVo {
    return OrderBigTableKoreaTrackVoToJSONTyped(json, false);
}

export function OrderBigTableKoreaTrackVoToJSONTyped(value?: OrderBigTableKoreaTrackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderId': value['orderId'],
        'transportCompanyCode': value['transportCompanyCode'],
        'main': value['main'],
        'trackingNumber': value['trackingNumber'],
    };
}

